import { Dropdown, DropdownOpener, DropdownProps } from '@tlx/atlas';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useValidatedFormSelect } from './hooks/useValidatedFormSelect';
import { ErrorMessage } from './ErrorMessage';

export const ValidatedDropdown = forwardRef<HTMLSelectElement, DropdownProps>(function ValidatedDropdown(
    { children, ...props },
    ref,
) {
    const { showError, errorMessage, inputProps } = useValidatedFormSelect({
        ...props,
        ref,
    });

    return (
        <>
            <Dropdown {...inputProps} data-testid={props['data-testid']}>
                <DropdownOpener
                    className={classNames('atl-w-full', {
                        'atl-border-red-100': showError,
                    })}
                />
                {children}
            </Dropdown>
            <ErrorMessage errorMessage={errorMessage} showError={showError} />
        </>
    );
});
